<script>
import ModuleTitle from '../common/ModuleTitle.vue'

import { getShadowColor, getPageThemeColor } from '@/utils/modules/getStyles'
import { filtersRichtext } from '@/utils/common'

export default {
  name: 'Comp5',
  components: { ModuleTitle },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: {
    getShadowColor, getPageThemeColor, filtersRichtext,
    onModuleItem(v) {
      this.$emit('onModuleItem', v)
    },
    openLawWebsit() {
      window.open('http://www.12348.gov.cn')
    }
  }
}
</script>

<template>
  <div class="modules-id-5">
    <module-title :title="moduleOption.title" margin-bottom="30" />
    <div v-if="moduleOption.id === 5" class="comp-transverse-3 modules-id-5-content">
      <div
        v-for="v in moduleOption.list.slice(0, 2)"
        :key="`modules-5-${v.id}`"
        @click="onModuleItem(v)"
      >
        <div
          class="item item-special"
          :style="{boxShadow: `0 3px 10px 0 ${getShadowColor(path)}`}"
        >
          <p class="item-title" :style="{backgroundColor: getPageThemeColor(path)}">
            {{ v.headline | textLenHandler(18) }}
          </p>
          <p v-if="filtersRichtext(v.memo)" class="item-content h-line-1">{{ v.memo | filtersRichtext }}</p>
          <p v-else class="item-content">暂无文本内容</p>
        </div>
      </div>
      <div @click.stop="openLawWebsit">
        <div
          class="item item-special"
          :style="{boxShadow: `0 3px 10px 0 ${getShadowColor(path)}`}"
        >
          <p class="item-title" :style="{backgroundColor: getPageThemeColor(path)}">
            法律援助服务
          </p>
          <p class="item-content h-line-1">中国法律服务网(12348中国法网)</p>
        </div>
      </div>
      <!-- <div class="law-websit" @click.stop="openLawWebsit">
        <el-image :src="require('imgs/modules/law.png')" alt="law" class="law-logo" fit="cover" />
        <div class="law-right">
          <p class="law-title">中国法律服务网</p>
          <p class="law-tip">(12348中国法网)</p>
        </div>
      </div> -->
    </div>
    <div v-else class="comp-transverse-3 modules-id-5-content">
      <div
        v-for="v in moduleOption.list.slice(0, 2)"
        :key="`modules-5-${v.id}`"
        @click="onModuleItem(v)"
      >
        <div
          class="item"
          :style="{boxShadow: `0 3px 10px 0 ${getShadowColor(path)}`}"
        >
          <p class="item-title" :style="{backgroundColor: getPageThemeColor(path)}">
            {{ v.headline | textLenHandler(18) }}
          </p>
          <p v-if="filtersRichtext(v.memo)" class="item-content h-line-2">{{ v.memo | filtersRichtext }}</p>
          <p v-else class="item-content">暂无文本内容</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-5-content {
  display: flex;
  flex-direction: column;
  row-gap: 26px;
  .item {
    width: 450px;
    height: 151px;
    background-color: #fff;
    border-radius: 5px;
    padding: 20px;
    box-sizing: border-box;
    .item-title {
      min-width: 164px;
      height: 35px;
      text-align: center;
      line-height: 35px;
      white-space: nowrap;
      border-radius: 18px;
      display: inline-block;
      padding: 0 30px;
      box-sizing: border-box;

      font-size: 17px;
      font-weight: bold;
      color: #FEFEFE;
    }
    .item-content {
      width: 408px;
      font-size: 15px;
      font-weight: 600;
      color: #000;
      line-height: 25px;
      margin-top: 28px;
    }
  }
  .item-special {
    height: auto;
    padding: 12px 20px;
    .item-title {
      height: 30px;
      line-height: 30px;
      border-radius: 18px;
    }
    .item-content {
      margin-top: 14px;
    }
  }
  .law-websit {
    width: 340px;
    box-shadow: 0px 3px 10px 0px rgba(7,60,0,0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    column-gap: 16px;
    padding: 10px;
    background-color: #fff;
    .law-logo {
      width: 60px;
      height: 60px;
    }
    .law-right {
      height: 60px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      row-gap: 6px;
      .law-title {
        font-size: 15px;
        color: #000;
      }
      .law-tip {
        font-size: 13px;
        color: #999;
      }
    }
  }
}
</style>
